const Image_Exported = {
    "profile_picture": require('./images/IMG-20250414-WA0006.jpg'),
    "user-picture": require('./images/gare.PNG'),
    "madel-image": require('./images/star medal.png'),
    "Book-not-found": require('./images/vecteezy_young-man-painting-on-easel_69294864.png'),
    "google-logo": require('./images/google.png'),
    "blog-input": require('./images/Gray White Minimalist Personal Profile Linkedin Banner.png'),
    "self-png_1": require('./images/32249-removebg-preview.png'),
    "self-png_2": require('./images/32254-removebg-preview.png'),
    "self-png_3": require('./images/32257-removebg-preview.png'),
}
export default Image_Exported;